
import React, { useState, useEffect } from "react";
import { slice } from "lodash";
import { Link } from "react-router-dom";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export default function Craft() {
  
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2
  }
};

          


  const [apilink] = useState(
         "../databases/packagesCraft.json"
       );
       //const [apilink, setApilink] = useState([])
       const [post, setPost] = useState([]);
       //const [ setIsCompleted] = useState(false);
       const [index] = useState();
       let initialPosts = slice(post, 0, index);
       const getData = (apilink) => {
         fetch(apilink)
           .then((res) => res.json())
           .then((json) => setPost(json))
           .catch((e) => console.log(e));
       };
 
       useEffect(() => {
         getData(apilink);
       }, [apilink]);
 


   return (
    <>

    
      <section className="craft">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="heading">Craft Your International Journey</h2>
                <div className="col-md-6">
                <p>Didn't come across what you were looking for? Let's craft a personalized adventure just for you! Dive into these trending destinations for tailor - made journeys!</p>
                </div>
            </div>
           

 <Carousel responsive={responsive}infinite={true}autoPlay={true}autoPlaySpeed={3000}swipeable={true} draggable={true}ssr={true}removeArrowOnDeviceType={["tablet", "mobile"]}>

                  {
                        initialPosts.map((item, i) => {
                         
                          return (
                           
                            <React.Fragment key={item.id}> 
                              {(() => {
                                return (
                                     
                                        <Link to={`/TravelPackagesCraft/${item.destinationname}`} className="subCraft">
                                            <img src={`${item.destinationImg}`} alt=""/>
                                            <p>{ `${item.destinationname}`}</p>
                                        </Link>
                                      
                                    );
                                    
                                  })()}
                            </React.Fragment>
                         


                              );
                             
                            })}                
         
</Carousel>

            

        </div>
    </div>
</section>
    </>
    
  )
  
}

